export function useLocalStorage(storageKey) {
    const saveToStorage = (data) => {
        try {
            const serializedData = JSON.stringify({
                ...data,
                messages: data.messages.map((msg) => ({
                    ...msg,
                    timestamp: msg.timestamp.toISOString(),
                })),
            });
            localStorage.setItem(storageKey, serializedData);
        }
        catch (error) {
            console.warn('Failed to save conversation to localStorage:', error);
        }
    };
    const loadFromStorage = () => {
        try {
            const stored = localStorage.getItem(storageKey);
            if (!stored)
                return null;
            const parsed = JSON.parse(stored);
            return {
                ...parsed,
                messages: parsed.messages.map((msg) => ({
                    ...msg,
                    timestamp: new Date(msg.timestamp),
                })),
            };
        }
        catch (error) {
            console.warn('Failed to load conversation from localStorage:', error);
            return null;
        }
    };
    const clearStorage = () => {
        try {
            localStorage.removeItem(storageKey);
        }
        catch (error) {
            console.warn('Failed to clear localStorage:', error);
        }
    };
    return { saveToStorage, loadFromStorage, clearStorage };
}
